import React from "react";
import { Navigate } from "react-router-dom";

const getStoredUser = () => {
  try {
    const stored = localStorage.getItem("user");
    if (stored && stored !== "undefined" && stored !== "null") {
      return JSON.parse(stored);
    }
    return null;
  }
   catch (error) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return null;
  }
};

const ProtectedRoute = ({ children, adminOnly = false, allowedRoles = null }) => {
  const user = getStoredUser();

  // 1. Not logged in → redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 2. Admin-only route → block non-admin
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  // 3. Role-restricted route → block users not in allowedRoles
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = String(user.role || "").toLowerCase();
    const isAllowed = allowedRoles
      .map((r) => String(r).toLowerCase())
      .includes(userRole);

    if (!isAllowed) {
      // Admin trying to access employee-only route → go to admin dashboard
      // Employee trying to access other role route → go to their dashboard
      return (
        <Navigate
          to={user.role === "admin" ? "/admin/dashboard" : "/dashboard"}
          replace
        />
      );
    }
  }

  return children;
};

export default ProtectedRoute;